import Attributes from './Attributes';

export default Attributes;


// WEBPACK FOOTER //
// ./src/components/Query/Attributes/index.tsx